import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=5bdd1e13&scoped=true&"
import script from "./CompareTable.vue?vue&type=script&lang=js&"
export * from "./CompareTable.vue?vue&type=script&lang=js&"
import style0 from "./CompareTable.vue?vue&type=style&index=0&id=5bdd1e13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd1e13",
  null
  
)

export default component.exports